import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import dayjs from "dayjs";
import { orders } from "./svgs";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../reduxtoolkit/toastslice";

const ASSIGNEES = [
  "Provider",
  "Front/Back Office",
  "Lab",
  "Billing",
  "MA",
  "All",
];

export default function AddNotesModal({
  open,
  defaultAssignee = ["Provider"], // default as array now
  defaultMessage = "",
  setNoteModalOpen,
  setFetchedData,selectedCard,refreshDashboard
}) {
  const [assignees, setAssignees] = useState(defaultAssignee);
  const [message, setMessage] = useState(defaultMessage);
  const dialogRef = useRef(null);
const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');
  const dispatch=useDispatch()
    const handleToastClose = () => {
    setOpenToast(false);
  };
    const practiseid = window.getPracticeId();
    const userConfig = useSelector((state) => state.userconfig);
    const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    if (open) {
      setAssignees(Array.isArray(defaultAssignee) ? defaultAssignee : []);
      setMessage(defaultMessage || "");
    }
  }, [open, defaultAssignee, defaultMessage]);

const [manualSelection, setManualSelection] = useState({}); // Track manual clicks

const isAllSelected = assignees.includes("All");


// Auto-detect "bill" or "billing" in message
useEffect(() => {
  const containsBilling = /bill/i.test(message);
  if (!manualSelection["Billing"]) {
    setAssignees((prev) => {
      if (containsBilling && !prev.includes("Billing")) {
        return [...prev, "Billing"];
      } else if (!containsBilling && prev.includes("Billing")) {
        return prev.filter((a) => a !== "Billing");
      }
      return prev;
    });
  }
}, [message, manualSelection]);
  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setNoteModalOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, ]);
useEffect(() => {
  if (assignees.includes("All")) return; // ⛔ stop auto logic

  const containsBilling = /bill/i.test(message);

  if (!manualSelection["Billing"]) {
    setAssignees((prev) => {
      if (containsBilling && !prev.includes("Billing")) {
        return [...prev, "Billing"];
      } else if (!containsBilling && prev.includes("Billing")) {
        return prev.filter((a) => a !== "Billing");
      }
      return prev;
    });
  }
}, [message, manualSelection, assignees]);

  if (!open) return null;
const toggleAssignee = (label) => {
  setAssignees((prev) => {
    // If clicking ALL
    if (label === "All") {
      return prev.includes("All") ? [] : ["All"];
    }

    // If ALL is active, block other toggles
    if (prev.includes("All")) {
      return prev;
    }

    // Normal toggle
    return prev.includes(label)
      ? prev.filter((a) => a !== label)
      : [...prev, label];
  });

  setManualSelection((prev) => ({ ...prev, [label]: true }));
};


  const handleAdd = () => {
    console.log({ assignees, message });
    // Add further logic to send assignees and message to parent or API
  };
 const handleSubmit = async () => {

 const userRole =assignees.join(', ')

 
    setIsSubmitting(true);
    // const userRole =assignees.join('- ')
    
    try {
      const createResponse = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/orders/create`, {
        department_id: 1,
        patient_name: `${selectedCard.firstname || ''} ${selectedCard.lastname || ''}`.trim(),
        tov: "FOLLOW UP", // purpose
        lov: selectedCard.lov,
        diagnosis: "",
        ordertype: "Notes", // tabs
        ordername: message, // buttons
        schedule: "f", // t/f-schedule
        // provider: selectedCard.linked_provider,
        provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
        user_role:userRole,
        status: "CREATED",
        confirm_status: "C", // C/E
       orderdate: selectedCard?.ts && dayjs(selectedCard.ts).isValid()
  ? dayjs(selectedCard.ts).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
        encounterid: 0,
        
      });

      if (createResponse.status === 200) {
        setToastMessage('Notes added successfully!');
        setToastSeverity('success');
        setOpenToast(true);

         dispatch(
                  showToast({
                    message: 'Notes added successfully!',
                    severity: "success",
                  }),
                );
        setMessage('')
     setFetchedData(prevData =>
  prevData.map(item =>
    item.id === selectedCard.id
      ? {
          ...item,
          orders: [
            ...(item.orders || []), // keep existing orders, fallback to empty array
            { id:createResponse.data, ordertype: "Notes", ordername: message, user_role:userRole } // add new order
          ],
        }
      : item // keep others unchanged
  )
);
;
     
        // // Ask parent to refresh dashboard so new Notes appear
        // try {
        //   if (typeof refreshDashboard === 'function') {
        //     await refreshDashboard(selectedCard?.patientid);
        //   }
        // } catch (e) {
        //   console.error('refreshDashboard failed', e);
        // }

    
          setOpenToast(false)
          setIsSubmitting(false);
        setNoteModalOpen(false)

      } else {
        throw new Error('Failed to add notes');
      }
    } catch (error) {
      setToastMessage('Failed to add notes. Please try again.');
      setToastSeverity('error');
      setOpenToast(true);
      setIsSubmitting(false);
    }
  };

  const pillClass = (label) => {
    const isActive = assignees.includes(label);
    if (isActive)
      return "px-4 py-2.5 rounded-full text-[14px] font-inter font-[400] font-medium bg-[#22C55E] text-white shadow";
    return "px-4 py-2.5 rounded-full text-[14px] font-inter font-[400] bg-[#E5E7EB] text-[#1D2951]/80";
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={()=>setNoteModalOpen(false)}
        aria-hidden="true"
      />
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        className="relative bg-white w-[92%] max-w-[560px] rounded-2xl shadow-2xl ring-1 ring-black/5 overflow-hidden"
      >
        <div className="px-4 py-2 pt-3 border-b border-[#EEF2F6] flex items-center justify-between">
          <h3 className="text-[18px] font-inter text-[#111827]">Add Notes</h3>
          <button onClick={()=>{setNoteModalOpen(false)}} aria-label="Close" className="p-1 pb-2">
            <FontAwesomeIcon icon={faXmark} color="#000000" />
          </button>
        </div>

        {/* Body */}
        <div className="px-3 py-3 space-y-5">
          {/* Assign Task */}
          <div>
            <div className="text-[14px] font-inter text-left text-[#000000] mb-3 font-medium">
              Assign Task to:
            </div>
            <div className="flex flex-wrap gap-3 px-5">
              {ASSIGNEES.map((label) => (
         <button
  key={label}
  type="button"
  disabled={isAllSelected && label !== "All"}
  className={`${pillClass(label)} ${
    isAllSelected && label !== "All"
      ? "opacity-50 cursor-not-allowed"
      : ""
  }`}
  onClick={() => toggleAssignee(label)}
>
  {label}
</button>

              ))}
            </div>
          </div>

          {/* Message */}
          <div>
            <div className="text-[14px] text-[#000000] text-left font-inter mb-3 font-medium">
              Message:
            </div>
            <div className="rounded-lg border border-[#E5E7EB]">
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={4}
                placeholder="Enter message here..."
                className="w-full resize-none rounded-lg px-3 py-2 outline-none placeholder:text-[#CCCCCC] text-[16px]"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-3 pb-4">
       <button
  onClick={handleSubmit}
  disabled={isSubmitting || !message.trim()} // disable if submitting or message empty
  className={`w-full py-3.5 rounded-lg font-inter text-[14px] ${
    isSubmitting || !message.trim()
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-[#000] text-white"
  }`}
>
  {isSubmitting ? "Submitting..." : "Add Notes"}
</button>


        </div>
      </div>
      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
}
